"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockFundingOpportunityList = exports.createOpprtunityArray = void 0;
const __1 = require("..");
const _1 = require(".");
function createOpprtunityArray() {
    const length = Math.floor(Math.random() * 10);
    const items = [];
    for (let i = 0; i < length; i++) {
        items.push((0, _1.createMockOpportunity)());
    }
    return items;
}
exports.createOpprtunityArray = createOpprtunityArray;
function createMockFundingOpportunityList(overwrites = {}) {
    const all = createOpprtunityArray();
    return Object.assign({ all, smartRaise: all.filter((o) => o.product === __1.Product.SMARTRAISE), smartMatch: all.filter((o) => o.product === __1.Product.SMARTMATCH), smartMatchIsDisabled: true, showcased: all[0] }, overwrites);
}
exports.createMockFundingOpportunityList = createMockFundingOpportunityList;
//# sourceMappingURL=FundingOpportunityList.factory.js.map